import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import '../styles/Hero.css';
import Compensation from '../components/Compensation';
import { translations } from '../translations';

const Hero = ({ showProjectDetail, onExploreClick, onBackToHome, language, setLanguage }) => {
  const t = translations[language];
  const [showModal, setShowModal] = useState(false);
  const [mounted, setMounted] = useState(false);
  const baseUrl = process.env.PUBLIC_URL || '';
  const backgroundImageUrl = `${baseUrl}/assets/background_1.png`;

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showModal ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [showModal]);

  useEffect(() => {
    if (!showModal) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape') setShowModal(false);
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [showModal]);

  const handleCloseModal = useCallback((e) => {
    if (e.target === e.currentTarget || e.target.closest('.modal-close')) {
      setShowModal(false);
    }
  }, []);

  const readMoreContent = useMemo(() => 
    t.hero.readMoreContent ? t.hero.readMoreContent.split('\n\n') : [],
    [t.hero.readMoreContent]
  );

  if (showProjectDetail) {
    return (
      <div id="project-detail">
        <Compensation onBackToHome={onBackToHome} language={language} setLanguage={setLanguage} />
      </div>
    );
  }

  return (
    <>
      <section 
        id="home" 
        className="hero"
        style={{ '--hero-bg-image': `url(${backgroundImageUrl})` }}
      >
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              <span>{t.hero.badge}</span>
            </div>
            {t.hero.title && (
              <h1 className="hero-title">{t.hero.title}</h1>
            )}
            {language === 'english' ? (
              <p 
                className="hero-description"
                dangerouslySetInnerHTML={{ __html: t.hero.description }}
              />
            ) : (
              <p className="hero-description">{t.hero.description}</p>
            )}
            <button 
              className="btn btn-hero btn-read-more" 
              onClick={() => setShowModal(true)}
              type="button"
            >
              {t.hero.readMore}
            </button>
          </div>
        </div>
        <div className="hero-gradient"></div>
      </section>

      {showModal && mounted && createPortal(
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="modal-close" 
              onClick={() => setShowModal(false)} 
              aria-label="Close"
              type="button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 6L6 18"></path>
                <path d="M6 6l12 12"></path>
              </svg>
            </button>
            <div className="modal-body">
              <h2 className="modal-title">{t.hero.badge}</h2>
              {readMoreContent.map((paragraph, index) => (
                <p key={index} className="modal-paragraph">{paragraph}</p>
              ))}
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default Hero;
